import { combineReducers } from 'redux';

import { Actions, ActionTypes } from '../../../entities/auth/session/actions';
import resetPassword from './reset/reducers';

export const loading = (state = false, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.SESSION_CREATE_REQUEST:
			return true;
		case ActionTypes.SESSION_CREATE_FAILURE:
		case ActionTypes.SESSION_CREATE_RECEIVE:
			return false;
		default:
			return state;
	}
};

export const valid = (state = true, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.SESSION_CREATE_FAILURE:
			return false;
		case ActionTypes.SESSION_CREATE_RECEIVE:
		case ActionTypes.SESSION_CREATE_REQUEST:
			return true;
		default:
			return state;
	}
};

export const error = (state: Error | null = null, action: Actions = {} as any): Error | null => {
	switch (action.type) {
		case ActionTypes.SESSION_CREATE_FAILURE:
			return action.payload.error;
		case ActionTypes.SESSION_CREATE_RECEIVE:
			return null;
		default:
			return state;
	}
};

export interface ILoginPageState {
	valid: ReturnType<typeof valid>;
	error: ReturnType<typeof error>;
	loading: ReturnType<typeof loading>;
	resetPassword: ReturnType<typeof resetPassword>;
}

const login = combineReducers<ILoginPageState>({
	valid,
	error,
	loading,
	resetPassword
});

export default login;
